import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import postal from 'postal';
import Loading from '../../../../shared/loading';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import copyToClipboard from '../../../../shared/copy-to-clipboard';
import ErrorBoundary from '../../../../shared/error-boundary';
import { generatePermaLink } from '../../../../services/wire/edit-services';
import { whenAllValid } from '../channel-editor-postal';

const edCh = postal.channel('editor');

export default class PermalinkControl extends Component {
  static propTypes = {
    wireId: PropTypes.number.isRequired,
    wireTitleLength: PropTypes.number.isRequired,
    wireCategoryId: PropTypes.number,
    permalink: PropTypes.string.isRequired,
    wirePublished: PropTypes.bool,
  }

  static defaultProps = {
    wireCategoryId: null,
    wirePublished: false,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      interestsValid: !!this.props.wireTitleLength && !!this.props.wireCategoryId,
      permalink: this.props.permalink,
      wirePublished: this.props.wirePublished,
    };

    this.submit = this.submit.bind(this);
    this.generateLink = this.generateLink.bind(this);

    edCh.subscribe('wire-unpublished', () => this.setState({ wirePublished: false }));
  }

  submit(e) {
    e.preventDefault();

    const fields = ['title', 'category'];
    whenAllValid({
      fields,
      action: () => _.each(fields, d => edCh.publish(`validate.${d}`)),
      done: () => this.setState({ interestsValid: true }, this.generateLink),
    });
  }

  generateLink() {
    if (this.state.permalink || !this.state.interestsValid) {
      return;
    }

    this.loading.start();
    generatePermaLink(this.props.wireId)
      .then(result => this.setState({ permalink: result.data.permalink }))
      .catch(e => defaultOnErrorHandler(e, 'Error generating permalink'))
      .finally(() => this.loading.stop());
  }

  render() {
    return (
      <ErrorBoundary>
        <aside className="sidebar-item no-top-margin">
          <section className="form-group no-top-margin">
            {
              this.state.wirePublished
                ? <span className="sidebar-item-desc">Sharable link</span>
                : (
                  <a href="#" className="sidebar-item-link" onClick={this.submit}>
                    Create sharable link
                  </a>
                )
            }
            {!this.state.wirePublished && <Loading variant="sip" ref={el => (this.loading = el)} />}
            {!!this.state.permalink && (
              <p className="sidebar-item-group">
                <input className="sidebar-item-input-text sidebar-item-url" type="text" readOnly value={this.state.permalink} />
                <button
                  className="sidebar-item-button"
                  type="button"
                  onClick={() => copyToClipboard(this.state.permalink)}
                >
                  Copy
                </button>
              </p>
            )}
          </section>
        </aside>
      </ErrorBoundary>
    );
  }
}
